import { Content, Row, Col, H1, H2, H3} from 'components/common'
import { React, styled, Image, mq } from 'x'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { custom } from '../../components/custom.css';

const Container = styled.div`
  padding: 30px 0;

  .custom {
    @media (min-width: 2000px) {
      max-width:1366px;
      margin:0 auto;
    }
  }
`

const Title = styled(H1)`
  max-width: 100%;
  color: #3e4d72;
  text-align:center;
  width: 100%;
  margin-bottom: 30px;
  font-size:42px;
  line-height:1.2;
  font-weight:800;
`

const Wrapper = styled.div`
  ${mq.above('md')} {
    padding:60px;
  }
  background-color:#EFEFEF;
  padding:60px 30px;
  margin-left:auto;
  margin-right:auto;
  flex:1 1 100%
`

const Testimonial = styled.div`
  ${mq.above('md')} {
    padding: 30px 80px;
  }
  padding:30px 30px 60px 30px;

  ${mq.below('sm')} {
    padding: 15px 15px 60px 15px;
  }
`

const Inner = styled.div`
  background-color: #FFF;
  box-shadow: 8px 8px 20px rgba(0, 0, 0, 0.3);

  ${mq.below('sm')} {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.2);
  }
`

const ImageWrapper  = styled.div`
    > div {
      height:300px;
      overflow:hidden;
      img {
        object-fit: cover;
        margin:0 auto;
        width:100%;
        max-width: 100%;
        height:auto;
      }
    }
`
const TestimonialContent = styled.div`
  padding:30px;
  ${mq.below('md')} {
    padding:30px 15px;
  }
`

const Name = styled(H3)`
  color:#000;
  font-size:32px;
  font-weight: 800;
  margin-top:0;
  margin-bottom: 20px;
`

const Review = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.4;
  margin:0;
  display:flex;

  blockquote {
    margin:0;
    padding:30px;

    @media (min-width: 1200px){
      min-height:280px;
    }
    
    ${mq.below('md')} {
      padding:30px 15px;
      min-height:auto;
    }
  }

  span {
    display:block;
    position:relative;
    font-size: 60px;
    line-height:60px;
    font-weight: 800;

    &.startQuote {
      align-self: flex-start;
    }

    &.endQuote {
      align-self: flex-end;
    }
    ${mq.below('sm')} {
      font-size:30px;
      line-height:30px;
    }
  }
`


const TestimonialsCarousel = props => {

  const responsive = {
    desktop: {
      breakpoint: { max: 6000, min: 1024 },
      items: 2,
      partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    },
    tablet: {
      breakpoint: { max: 1200, min: 464 },
      items: 1,
      partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 0 // this is needed to tell the amount of px that should be visible.
    }
  }

  return (
    <Container>
      <Content>
        <Row>
          <Col>
            <Title >What our Students Say</Title>
          </Col>
        </Row>
      </Content>
      <Wrapper >
        <div className="custom">
          <Carousel responsive={responsive} infinite={true} autoPlay={true} autoPlaySpeed={6000} arrows={false} showDots={true}>
            {
              props.data.testimonials.map((item, index) => (
                <Testimonial key={ item.id } >
                  <Inner>
                    {item?.acf?.image?.imgixImageWp?.fluid && (
                      <ImageWrapper>
                        <Image
                          fluid={item.acf.image.imgixImageWp.fluid}
                          title={item.acf.name} 
                        />
                      </ImageWrapper>
                    )}
                    <TestimonialContent>
                      <Name>{ item.acf.name }</Name>
                      <Review>
                        <span className="startQuote">“</span>
                          <blockquote>{ item.acf.quote }</blockquote>
                        <span className="endQuote">”</span>
                      </Review>
                    </TestimonialContent>
                  </Inner>
                </Testimonial>
              ))
            }
          </Carousel>
        </div>
      </Wrapper>
    </Container>
  )
}

export default TestimonialsCarousel
